import React from "react";
import { connect } from 'react-redux';

import { Actions as ASSETACTIONS } from '../../../store/actions/assetActions';

import { XMarkIcon } from "@heroicons/react/20/solid";
import UnassignEmployee from "../assignments/UnassignEmployee";

const AssignModal = ({
    isModalOpen,
    closeModal,
    asset
}) => {

    if (!isModalOpen) return null

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}>
            <div className="modal-dialog" style={{ width: "50%" }}>
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-primary-dark" style={{ padding: 20, position: 'sticky', top: 0, zIndex: 50 }}>
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={closeModal}><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                </li>
                            </ul>
                            <h3 className="block-title">Unassign {asset}</h3>
                        </div>
                        <div className="block-content" style={{ paddingBottom: 15 }}>
                            <UnassignEmployee  />
                            <div className="clearfix" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {

    return {
        isModalOpen: state.asset?.unassignModal,
        asset: state.asset?.item?.name
    };
};

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(ASSETACTIONS.unassignEmployeeModal()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AssignModal)